import { api } from "@/lib/api";

export const salesOrdersApi = {
  meta: () => api.get("/sales-orders/meta").then((r) => r.data),
  stats: () => api.get("/sales-orders/stats").then((r) => r.data),
  list: (params) => api.get("/sales-orders", { params }).then((r) => r.data),
  get: (id) => api.get(`/sales-orders/${id}`).then((r) => r.data),
  create: (body) => api.post("/sales-orders", body).then((r) => r.data),
  update: (id, body) => api.put(`/sales-orders/${id}`, body).then((r) => r.data),
  setStatus: (id, status, note) => api.patch(`/sales-orders/${id}/status`, { status, note }).then((r) => r.data),
  requestRevision: (id, changes, reason) => api.post(`/sales-orders/${id}/revisions`, { changes, reason }).then((r) => r.data),
  decideRevision: (id, rid, decision, note) => api.patch(`/sales-orders/${id}/revisions/${rid}`, { decision, note }).then((r) => r.data),
};

export const SO_STATUS_STYLE = {
  Draft: "bg-slate-100 text-slate-700",
  Confirmed: "bg-blue-50 text-blue-700 border border-blue-200",
  "Production Planning": "bg-violet-50 text-violet-700 border border-violet-200",
  "In Production": "bg-indigo-50 text-indigo-700 border border-indigo-200",
  "Partially Dispatched": "bg-amber-50 text-amber-700 border border-amber-200",
  Completed: "bg-teal-50 text-teal-700 border border-teal-200",
  Closed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Cancelled: "bg-rose-50 text-rose-700 border border-rose-200",
};

export const PRIORITY_STYLE = {
  Low: "bg-slate-100 text-slate-600",
  Normal: "bg-blue-50 text-blue-700",
  High: "bg-amber-50 text-amber-700",
  Urgent: "bg-rose-50 text-rose-700",
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
